(function($) {
    var shouldSkipBucket = false;
    const buildBucket = {
        is_bucket_added: false,
        empty_build_bucket_message: "Please make Build a Bucket selection before proceeding.",
        arrowIcon: `
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"></path>
            </svg>`,
        init: function() {
            window.buildBucket = {};

            this.initProductsCarousel();
            this.nextStep();

            this.initMinusQuantityButton();
            this.initAddQuantityButton();

            this.skipBucket();

            this.initBuildBucketAddToCart();
            this.initBuildBucketCheckout();
        },
        /**
         * Initialize the buckets on the first step
         */
        initProductsCarousel: function() {
            let slider = $('.js-mining-bucket__products').slick({
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: false,
                verticalSwiping: false,
                vertical: true,
                centerMode: true,
                centerPadding: "10px",
                prevArrow: `<button type="button" class="slick-btn slick-prev">${buildBucket.arrowIcon}</button>`,
                nextArrow: `<button type="button" class="slick-btn slick-next">${buildBucket.arrowIcon}</button>`,
                responsive: [
                    {
                      breakpoint: 580,
                      settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                        infinite: false,
                        dots: false,
                        verticalSwiping: false,
                        vertical: false,
                        centerMode: false
                      }
                    },
                ]
            });

          slider.on('wheel', (function (e) {
                e.preventDefault();

                if (e.originalEvent.deltaY < 0) {
                    $(this).slick('slickNext');
                } else {
                    $(this).slick('slickPrev');
                }
            }));
          
           setTimeout(function(){
              jQuery('.mining-bucket__products .select-option .slick-current').trigger('click')
              console.log('slick is being loaded')
            }, 1000);
            
            slider.on('beforeChange', function(event, slick, currentSlideIndex, nextSlide) {
                var slide = $(this).find('.slick-slide').eq(nextSlide);
                const image = $('input', slide).data().image;
                var productTitle = $('input', slide).attr('produc-title');
                var productDescription = $('input', slide).attr('produc-metafield');
                var productInclusions = $('input', slide).attr('product-inclusions');
                var productVariantID = $('input', slide).val();
                var $descriptionContainer = $('.bucket--richtext.test');

                
              
                $descriptionContainer.addClass('hidden');
                $('.mining-bucket__main-thumb > img').attr('srcset', image);
                $('.bucket--description--head').text(productTitle);

                console.log(productDescription.length);
              
                if(productDescription.length == 0){
                  if(productInclusions.length != 0){
                    $('.bucket--description--includes').css('display', 'block');
                  }else{
                     $('.bucket--description--includes').css('display', 'none');
                  }
                 
                }else{
                  $('.bucket--description--includes').css('display', 'block');
                }
              
                if(productInclusions.length != 0){
                  var output="";
                   jQuery.each( productInclusions.split(","), function( i, val ) {
                      
                    output= output + "<li>"+val.substring(1, val.length-1)+"</li>"
                  });
                  
                  
                  $('.bucket--richtext.one.descriptions').html('<ul>'+output+'</ul>');

                }else{
                  console.log('I was here else')
                     $('.bucket--richtext.one.descriptions').html(productDescription);
                }
                 // if(jQuery(window).width() == 580){
                 
                    jQuery('.select-items div').on('click', function(){
                      console.log('Here')
                        var dataValue = jQuery(this).attr('data-value')
                        jQuery('.select-option.new--mobile select#select-bucket').val(dataValue)
                    })
                // }
              
                console.log('Selected. Product Title:', productTitle);
              
                console.log("Before: "+productVariantID)
                // jQuery('option[data-product-id="'+productVariantID+'"]').attr('selected','selected');
              
              // var dataValue = jQuery(this).attr('data-value')  
              // jQuery('.select-option.new--mobile select#select-bucket').val(dataValue)

                $("select#select-bucket.for-desktop").val(productVariantID).attr('selected','selected');
                $('.desktop-only .select-items-wrapper .select-items div[data-value="'+productVariantID+'"]').trigger('click')

              // $.each(productInclusions,function(i){
              //    console.log(array[i]);
              // });
              
                
            });

            $('.slick-slide', slider).on('click', function(e) {
                const slideIndex = $(this).data('slick-index');
                slider.slick('slickGoTo', slideIndex);

              // try {

               var currentTotalAddon = parseFloat(jQuery('.bucket-total-price span.amount').attr('data-addon'));
               var newTotal = currentTotalAddon + parseFloat(jQuery('.desktop-only #select-bucket option:selected').data('price'));

              if( currentTotalAddon > 0 ){
                  jQuery('.bucket-total-price span.amount').text( jQuery('.mining-bucket__products .slick-current input').data('currency') + newTotal.toLocaleString(jQuery('html').attr('lang'))  +' '+Shopify.currency.active )
                  jQuery('.bucket-total-price span.amount').attr('data-value', newTotal.toFixed(2) )
              }else{
                jQuery('.bucket-total-price span.amount').text( jQuery('.mining-bucket__products .slick-current input').data('currency') + jQuery('.desktop-only #select-bucket option:selected').data('price').toLocaleString(jQuery('html').attr('lang'))  +' '+Shopify.currency.active )
                  jQuery('.bucket-total-price span.amount').attr('data-value',jQuery('.desktop-only #select-bucket option:selected').data('price') )
              }
              
            });

             jQuery('.js-bb-sub').addClass('disabled')

        },

        /**
         * TODO: Skip bucket function here
         */
        skipBucket: function() {
            var self = this;
            $('.js-skip-the-bucket').on('click', function() {
                shouldSkipBucket = true;
                console.log(shouldSkipBucket);
            });
        },

        nextStep: function() {
            $('.js-mining-bucket__next').on('click', function(el) {
                $(`.build-bucket__step`).hide();
                $(`.build-bucket__step[data-js-step="${el.target.dataset.jsStep}"]`).fadeIn();
            });
        },

        /** Store all selected product during the build bucket wizard
         *  e.g options that has 1 or more quantity
         **/
        setBucketSelection: function() {
            window.buildBucket.addons = [];
            $(`.js-get-addons .item`).each(function (ix, em) {
                let selectedQuantity = parseInt($(em).find(`input[type="number"]`).val());

                if (selectedQuantity > 0) {
                    const item = buildBucket.setProductItem(em, selectedQuantity);
                    window.buildBucket.addons.push(item);
                }
            });

            window.buildBucket.accessories = [];
            $(`.js-get-accessories .item`).each(function (ix, em) {
                let selectedQuantity = parseInt($(em).find(`input[type="number"]`).val());

                if (selectedQuantity > 0) {
                    const item = buildBucket.setProductItem(em, selectedQuantity);
                    window.buildBucket.accessories.push(item);
                }
            });
        },
        setProductItem: function(product, quantity = 1) {
            const item = {};

            item.id = $(product).attr('data-variant-id');
            item.product_id = $(product).attr('data-product-id');
            item.price = $(product).attr('data-price');
            item.compare_at_price = $(product).attr('data-compare-at-price') ?? null;
            item.title = $(product).attr('data-title') ?? ""; // TODO: Check if still needed in the updated design
            item.image_url = $(product).attr('data-image') ?? ""; // TODO: Check if still needed in the updated design
            item.quantity = quantity;

            return item;
        },
        setBucketItem: function() {
            if (shouldSkipBucket) {
                console.log('Skipping setBucketItem due to skip action.');
                shouldSkipBucket = false;
                return;
            }
            const viewportWidth = $(window).width();

            if (viewportWidth <= 580) {
                selectedBucket = $('[name="select-bucket"]:checked');
            } else {
                selectedBucket = $('[name="select-bucket-desktop"]:checked');
            }
            console.log('Selected Bucket:', selectedBucket);
            if (selectedBucket.length > 0) {
                window.buildBucket.bucket = this.setProductItem(selectedBucket);
                
            } else {
                window.buildBucket.bucket = null;
            }

          setTimeout(function () {
                console.log('Bucket added Items')
                showProgress();
                collectionSlider();
            }, 100);
         
        },
        initMinusQuantityButton: function() {
            $(document).on('click', '.js-bb-sub', function (e) {
                e.preventDefault();
                let bucket_qty = $(e.target).parents('.bucket-qty').find(`input[type='number']`).val();
                let updated_qty = parseInt(bucket_qty) - 1;
                if (updated_qty <= 0) {
                    updated_qty = 0;
                    
                  jQuery(this).addClass('disabled')
                }
              
                $(e.target).parents('.bucket-qty').find(`input[type='number']`).val(updated_qty).trigger('change');

                var currentTotal = jQuery('.bucket-total-price span.amount').attr('data-value');
                var addOnTotal = jQuery(this).parent().parent('.add--ons').attr('data-price'); 
                var accessTotal =  jQuery(this).parent().parent('.access').attr('data-price'); 
                var total = 0;
                var currentTotalAddon = parseFloat(jQuery('.bucket-total-price span.amount').attr('data-addon'));
                var TotalAddon = 0;
                // var total = parseFloat( currentTotal + addOnTotal );

              
                if(addOnTotal > 0){
                  if(updated_qty >= 1){
                    total = parseFloat(currentTotal) - parseFloat(addOnTotal);
                  }else{
                    total = parseFloat(currentTotal) - parseFloat(addOnTotal);
                  }
                  
                  TotalAddon = currentTotalAddon - parseFloat(addOnTotal)
               
                  
                }

                if(accessTotal > 0){
                  if(updated_qty >= 1){
                    total = parseFloat(currentTotal) - parseFloat(accessTotal);
                  }else{
                    total = parseFloat(currentTotal) - parseFloat(accessTotal); 
                  }

                  TotalAddon = currentTotalAddon - parseFloat(accessTotal)
                   
                }

                console.log("Current Total Addon: "+ TotalAddon)
                console.log("Current Total: "+ currentTotal)
                console.log("AddOn Total: "+ addOnTotal)
                console.log("Access Total: "+ accessTotal)
                console.log("Total: " + total)
                
                jQuery('.bucket-total-price span.amount').attr('data-value', total.toFixed(2).replace(/,/g, ''))
                jQuery('.bucket-total-price span.amount').attr('data-addon', TotalAddon.toFixed(2).replace(/,/g, ''))
                jQuery('.bucket-total-price span.amount').text( jQuery('.mining-bucket__products .slick-current input').data('currency') + total.toLocaleString(jQuery('html').attr('lang')) +' '+Shopify.currency.active )
                
              // try {}
              // catch(err) {
              //   jQuery('.bucket-total-price span.amount').attr('data-error', err.message )
              // }
              
                
                // console.log(Shopify.currency.active);
              
            });
        },
        initAddQuantityButton: function() {
            $(document).on('click', '.js-bb-add', function (e) {
                e.preventDefault();
                let bucket_qty = $(e.target).parents('.bucket-qty').find(`input[type='number']`).val();
                let updated_qty = parseInt(bucket_qty) + 1;

                 $(e.target).parents('.bucket-qty').find(`input[type='number']`).val(updated_qty).trigger('change');

                console.log("Quantity: "+updated_qty)
              
                var currentTotal = jQuery('.bucket-total-price span.amount').attr('data-value');
                var addOnTotal =  jQuery(this).parent().parent('.add--ons').attr('data-price'); 
                var accessTotal =  jQuery(this).parent().parent('.access').attr('data-price'); 
                var total = 0;
                var currentTotalAddon = parseFloat(jQuery('.bucket-total-price span.amount').attr('data-addon'));
                var TotalAddon = 0;
                
                if(addOnTotal > 0){
                   if(updated_qty >= 1){
                    total = parseFloat(currentTotal) + parseFloat(addOnTotal);
                  }else{
                     total = parseFloat(currentTotal) + parseFloat(addOnTotal);
                  }

                  console.log("Current Total Before Addon: "+ currentTotalAddon)
                  console.log("Current Total  addOnTotal: "+ addOnTotal)
                  
                   if(currentTotalAddon > 0){
                    TotalAddon = parseFloat(currentTotalAddon) + parseFloat(addOnTotal)
                  }else{
                    TotalAddon = parseFloat(addOnTotal)
                  }
                   // currentTotalAddon = parseFloat(currentTotalAddon) + parseFloat(addOnTotal)
                }

                if(accessTotal > 0){
                   if(updated_qty >= 1){
                    total = parseFloat(currentTotal) + parseFloat(accessTotal);
                  }else{
                     total = parseFloat(accessTotal); 
                  }
                   // currentTotalAddon = parseFloat(currentTotalAddon) + parseFloat(accessTotal)
                }

              
                console.log("Current Total Addon: "+ TotalAddon)
                console.log("Current Total: "+ currentTotal)
                console.log("AddOn Total: "+ addOnTotal)
                console.log("Access Total: "+ accessTotal)
                console.log("Total: " + total)

                jQuery('.bucket-total-price span.amount').attr('data-addon', TotalAddon.toFixed(2).replace(/,/g, ''))
                jQuery('.bucket-total-price span.amount').attr('data-value', total.toFixed(2).replace(/,/g, '')) 
                jQuery('.bucket-total-price span.amount').text( jQuery('.mining-bucket__products .slick-current input').data('currency') + total.toLocaleString(jQuery('html').attr('lang')) +' '+Shopify.currency.active )
              
            
            // try{
              
            // }catch(err) {
            //     jQuery('.bucket-total-price span.amount').attr('data-error', err.message )
            //   }
              
              jQuery(this).parent('.bucket-qty').find('.js-bb-sub').removeClass('disabled')

            });
        },
        /**
         * Function for checkout action
         * 
         * TODO: Add loading screen
         */
        initBuildBucketCheckout: function() {
            $('.js-build-bucket__checkout').on('click', function(e) {

                // clear cart data
                buildBucket.clearCart().then(() => {

                    // add new cart items
                    buildBucket.addProductsToCart().then(function(response) {
                        window.location.href = '/checkout';
                    });
                });
            })
        },
        /**
         * Function for Add To Cart action
         * 
         * TODO: Add loading screen
         */
        initBuildBucketAddToCart: function() {
            $('.js-build-bucket__add-to-cart').on('click', function(e) {
                e.preventDefault();
                $(this).removeClass('added-to-cart')
                $(this).addClass('added-to-cart')
              
                // add new cart items
                buildBucket.addProductsToCart().then(function({ items, sections }) {
        
                    /**
                     * TODO: Replace with proper event
                     * to open the cart drawer
                     * 
                     * window.location.href = '/cart' is just a temporary action
                     */
                    const cartDrawer = document.querySelector('cart-drawer')

                  
                    if (Array.isArray(items)) {
                        for (let index = 0; index < items.length; index++) {
                            const item = items[index]
                            item.sections = sections
                            cartDrawer.renderContents(item)
        
                            if (index + 1 == items.length) {
                                cartDrawer.classList.remove('is-empty');
                                
                                cartDrawer.open();
                                
                                // Call collectionSlider() after the cart drawer is open
                                collectionSlider();
                            }
                        }
                    }

                    setTimeout(function() { 
                         showProgress(); 
                    }, 100);
                });
            });
        },

        /**
         * Clear cart data, and used when
         * customer clicked on the Checkout button
         */
        clearCart: function() {
            return $.ajax({
                url: "/cart/clear.js",
                method: "POST",
                dataType: "JSON"
            })
        },
        addProductsToCart: function() {
            let _uid = +new Date();

            const items = this.setItemsForCart(_uid);
  
            if (items.length <= 0) {
                window.alert(this.empty_build_bucket_message);

                return;
            }

            return $.ajax({
                url: "/cart/add.js",
                data: {
                    items: items,
                    sections: 'cart-drawer,cart-icon-bubble'
                },
                method: "POST",
                dataType: "JSON",
                success: function (data) {
                    window.buildBucket.bucket = null;
                    return data
                },
                error: function (error) {
                    window.alert(error.responseJSON.description);
                }
            });
        },
        /**
         * Solely used to format the product data
         * 
         * 
         * @param {*} _uid 
         */
        setItemsForCart: function(_uid) {
            const items = [];
            this.setBucketSelection();
            this.setBucketItem();

            window.buildBucket.addons.forEach((el) => {
                const item = this.setItemForCart(el, _uid);
             
              items.push(item);
              
            });

            window.buildBucket.accessories.forEach((el) => {
                const item = this.setItemForCart(el, _uid);
                items.push(item);
            });

            const bucketItem = this.setItemForCart(window.buildBucket.bucket, _uid);
           
            // add selected bucket
            if (bucketItem?.id) {
                bucketItem.properties['_selected_Bucket'] = '✓';
                bucketItem.properties['_uid'] = _uid;
                bucketItem.properties['_selected_Bucket'] = '✓';
                items.push(bucketItem)
            }

            return items;
        },
        setItemForCart: function(data, _uid) {
            const item = {};

            if (! data) return item;

            item.id = data.id;
            item.quantity = data.quantity;
            item.properties = {};

            if (!this.is_bucket_added) {
                item.properties['Build a bucket'] = '✓';
                item.properties['_uid'] = _uid;
            }

            return item;
        }

    }

    $(document).ready(function() {
        buildBucket.init();
    })
    $(document).ready(function () {

      // Get the modal
      var modal = $("#myModal");
      
      // Get the button that opens the modal
      var btn = $(".bucket-prdt-list .item img");
      
      // Get the <span> element that closes the modal
      var span = $("#myModal .close");
      
      // When the user clicks the button, open the modal 
      btn.on('click', function(){
          $('.image-container').prepend('<div><img src="'+$(this).attr('src')+'"></div>')
          modal.css('display', 'flex');
      })
  
      span.on('click', function(){
          modal.hide();
           $('.image-container div').remove() 
      })

   
    
        

       $(document).on('click', 'button.drawer__close', function(e){
         e.preventDefault();
         if($('.mining--bucket__button.desktop-show .build-bucket__button--cart.js-build-bucket__add-to-cart').hasClass('added-to-cart')){
            location.reload();  
         }
      })
      
      jQuery('.first.build--bucket__numbers-tab').on('click', function(){
          jQuery('.build-bucket__step.bucket[data-js-step="1"]').css('display', 'block')
          jQuery('.build-bucket__step.bucket:not([data-js-step="1"])').css('display', 'none')
      })
      
      jQuery('.second.build--bucket__numbers-tab').on('click', function(){
          jQuery('.build-bucket__step.bucket[data-js-step="2"]').css('display', 'block')
          jQuery('.build-bucket__step.bucket:not([data-js-step="2"])').css('display', 'none')
      })
      
      jQuery('.third.build--bucket__numbers-tab').on('click', function(){
          jQuery('.build-bucket__step.bucket[data-js-step="3"]').css('display', 'block')
          jQuery('.build-bucket__step.bucket:not([data-js-step="3"])').css('display', 'none')
      })
      
       //  $('.select-items-wrapper .select-items div').on('click', function () {
       //     var optionSelected = $(this).attr('data-product-id');
       //    console.log(optionSelected)
       //    $('input[data-product-id="'+optionSelected+'"]').parent().trigger('click')
          
       // });
      
        $('.new--mobile, .desktop-only').each(function () {
          var selElmnt = $(this).find('select');
          var ll = selElmnt.find('option').length;
      
          var a = $('<div class="select-selected"></div>');
          a.html(selElmnt.find('option:selected').text());
          $(this).append(a);
      
          var selectItemsWrapper = $('<div class="select-items-wrapper select-hide"></div>');
          var b = $('<div class="select-items"></div');
          for (var j = 0; j < ll; j++) {
            var option = selElmnt.find('option').eq(j);
            var c = $('<div></div>');
            c.html(option.text());
      
            // Fetch the image URL from data-image attribute of the option
            var imageURL = option.data('image');
            var productId = option.data('product-id');
            var productValue = option.val();
      
            // Add srcset attribute to the select-items element
            c.attr('data-srcset', imageURL);
            c.attr('data-product-id', productId);
            c.attr('data-value', productValue);
      
            c.on('click', function (e) {
              var s = $(this).closest('.new--mobile, .desktop-only').find('select');
              var h = $(this).closest('.new--mobile, .desktop-only').find('.select-selected');
              for (var i = 0; i < s.find('option').length; i++) {
                if (s.find('option').eq(i).text() === $(this).text()) {
                  s.prop('selectedIndex', i);
                  h.html($(this).text());
                  $(this).addClass('same-as-selected');
                  $(this).closest('.new--mobile, .desktop-only').find('.select-items-wrapper').addClass('select-hide');
                  $(this).closest('.new--mobile, .desktop-only').find('.select-selected').removeClass('select-arrow-active');
      
                  // Log the srcset attribute to the console
                  console.log('srcset attribute:', $(this).data('srcset'));
      
                  // Get the srcset value from the console log
                  var newSrcset = $(this).data('srcset');
      
                  // Update the srcset attribute of the image with the new value
                  $('#bucket-image').attr('srcset', newSrcset);
                  $('input[data-product-id="'+$(this).data('product-id')+'"]').parent().trigger('click')
                 
                  break;
                }
              }
              h.click();
            });
            b.append(c);
          }
          selectItemsWrapper.append(b);
          $(this).append(selectItemsWrapper);
      
          a.on('click', function (e) {
            e.stopPropagation();
            closeAllSelect(this);
            $(this).next().toggleClass('select-hide');
            $(this).toggleClass('select-arrow-active');
            var $descriptionContainer = $('.bucket--richtext.test');

            $descriptionContainer.addClass('hidden');
            var selectedProductTitle = $(this).closest('.new--mobile, .desktop-only').find('select').find('option:selected').attr('produc-title');
            $('.bucket--description--head').text(selectedProductTitle);
            var selectedDescription = $(this).closest('.new--mobile, .desktop-only').find('select').find('option:selected').attr('produc-metafield');
            var productInclusions = $(this).closest('.new--mobile, .desktop-only').find('select').find('option:selected').attr('product-inclusions');
            // $('.bucket--richtext.one.descriptions').html(selectedDescription);

            if(productInclusions.length != 0){
                  var output="";
                   jQuery.each( productInclusions.split(","), function( i, val ) {
                      
                    output= output + "<li>"+val.substring(1, val.length-1)+"</li>"
                  });
                  
                  
                  $('.bucket--richtext.one.descriptions').html('<ul>'+output+'</ul>');

                }else{
                  console.log('I was here else')
                     $('.bucket--richtext.one.descriptions').html(selectedDescription);
                }

            
          });
        });
      
        $(document).on('click', function (e) {
          closeAllSelect(e.target);
        });
      
        function closeAllSelect(elmnt) {
          var arrNo = [];
          $('.select-items-wrapper').each(function (i) {
            if ($(elmnt).is($('.select-selected').eq(i))) {
              arrNo.push(i);
            } else {
              $('.select-selected').eq(i).removeClass('select-arrow-active');
            }
          });
          $('.select-items-wrapper').each(function (i) {
            if (!arrNo.includes(i)) {
              $(this).addClass('select-hide');
            }
          });
        }
      });
      
})(jQuery)